module.exports = __webpack_public_path__ + "static/media/JCB_logo.02331973.png";